import { pilot } from '~/services/serviceInstances';
import { PilotId } from '~/types/PilotId';

interface Request {
  sectionId: PilotId;
}

export const deleteClientSection = async ({ sectionId }: Request) => {
  return pilot.remove(`client-sections/${sectionId}/`);
};
